import React, { Component } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

import ThemeBox from "../../containers/theme/ThemeBox";

// import ScrollMenu from "react-horizontal-scrolling-menu";
// import ContentItem from "../../components/ContentItem";

class ThemeContent extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const themeList = result.data[0].listData;

    //console.log(intReturn)

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          themeList,
        });
      }
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + "/getTheme")
      .then((response) => response)
      .catch((errtor) => {});
  };

  render() {
    const { themeList } = this.state;
    return themeList ? (
      <ThemeBox
        themeSerial={themeList[0].themeSerial}
        title={themeList[0].title}
        comment={themeList[0].comment}
        imageS={themeList[0].imageS}
      />
    ) : null;
  }
}

export default shopContext(withRouter(ThemeContent));
